export var ReserveStatus;
(function (ReserveStatus) {
    // 无预约操作
    ReserveStatus[ReserveStatus["NoReserve"] = 0] = "NoReserve";
    // 预约失败
    ReserveStatus[ReserveStatus["ReserveFail"] = 1] = "ReserveFail";
    // 预约成功
    ReserveStatus[ReserveStatus["ReserveSuccess"] = 2] = "ReserveSuccess";
})(ReserveStatus || (ReserveStatus = {}));
